export const countryAbbreviations: { [key: string]: string } = {
  US: "USA",
};
